import styled from 'styled-components';

export const Container = styled.div`
  padding: 0.5rem 0;
`;

export const WarningBox = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 0.375rem;
  color: #856404;
  margin-bottom: 1.5rem;

  svg {
    flex-shrink: 0;
    margin-top: 0.125rem;
  }

  div {
    flex: 1;
    font-size: 0.875rem;
    line-height: 1.4;
  }
`;

export const PatientInfo = styled.div`
  background-color: #f8f9fa;
  border-radius: 0.375rem;
  padding: 1rem;
  margin-bottom: 1.5rem;
`;

export const PatientRow = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 0;
  border-bottom: 1px solid #dee2e6;

  &:last-child {
    border-bottom: none;
    padding-bottom: 0;
  }
`;

export const PatientLabel = styled.strong`
  min-width: 80px;
  font-size: 0.875rem;
  color: #495057;
`;

export const PatientValue = styled.span`
  font-size: 0.875rem;
  color: #212529;
  flex: 1;
`;

export const ActionButtons = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
`;

export const DownloadLink = styled.a`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  background-color: #007bff;
  color: white;
  border-radius: 0.375rem;
  text-decoration: none;
  font-size: 0.875rem;
  font-weight: 500;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0056b3;
    color: white;
    text-decoration: none;
  }

  svg {
    font-size: 1rem;
  }
`;

export const StatusMessage = styled.div<{
  success?: boolean;
  warning?: boolean;
  info?: boolean;
}>`
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  padding: 1rem;
  border-radius: 0.375rem;
  font-size: 0.875rem;
  line-height: 1.5;

  ${props =>
    props.success &&
    `
    background-color: #d4edda;
    border: 1px solid #c3e6cb;
    color: #155724;
  `}

  ${props =>
    props.warning &&
    `
    background-color: #f8d7da;
    border: 1px solid #f5c6cb;
    color: #721c24;
  `}

  ${props =>
    props.info &&
    `
    background-color: #d1ecf1;
    border: 1px solid #bee5eb;
    color: #0c5460;
  `}

  svg {
    flex-shrink: 0;
    margin-top: 0.125rem;
  }

  small {
    display: block;
    margin-top: 0.5rem;
    opacity: 0.8;
    font-size: 0.75rem;
  }
`;
